import routerProvider from '@refinedev/react-router-v6/legacy';
import { Button, Col, Row, Table, TableProps } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { IAssessmentQuestion } from 'interfaces/assessments';
import { TagField, TextField } from '@refinedev/antd';
import { tagColorByStatus } from 'utils/statusColorMapping';

TextField;

interface AssessmentQuestionListProps {
  tableProps: TableProps<IAssessmentQuestion>;
}

const QUESTION_STATUSES_MAP: Record<IAssessmentQuestion['status'], string> = {
  active: 'Ativo',
  inactive: 'Inativo',
  nullified: 'Anulada'
};

export const QuestionsTable = ({ tableProps }: AssessmentQuestionListProps) => {
  const { Link } = routerProvider;

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="plain_statement"
              key="plain_statement"
              title="Questão"
              render={value => <TextField value={value} />}
            />

            {tableProps?.dataSource &&
              tableProps?.dataSource[0]?.kind === 'objective' && (
                <Table.Column
                  dataIndex="alternatives"
                  key="alternatives"
                  title="Alternativas"
                  align="center"
                  render={value => <TextField value={value.length} />}
                />
              )}

            <Table.Column
              dataIndex="status"
              key="status"
              title="Status"
              render={(value: IAssessmentQuestion['status']) => (
                <TagField
                  color={tagColorByStatus(value)}
                  style={{ border: '1px solid #d9d9d9' }}
                  value={QUESTION_STATUSES_MAP[value]}
                />
              )}
            />

            <Table.Column
              title="Ações"
              dataIndex="actions"
              render={(_, record: IAssessmentQuestion) => {
                return (
                  <Link
                    to={`/evaluations/assessment_questions/edit/${record.id}`}
                  >
                    <Button icon={<EditOutlined />} size="small" />
                  </Link>
                );
              }}
            />
          </Table>
        </Col>
      </Row>
    </>
  );
};
